import { formatInTimeZone } from 'date-fns-tz';
import type React from 'react';
import type { DateStringStateProps } from './date-string-container';

export type DateStringOwnProps = {
  readonly date: string | number | Date;
  readonly formatString: string;
};

type DateStringProps = DateStringOwnProps & DateStringStateProps;

const DateString: React.FC<DateStringProps> = (props: DateStringProps) => {
  const { date, defaultTimezone, formatString } = props;
  return <>{formatInTimeZone(date, defaultTimezone, formatString)}</>;
};

export default DateString;
